/**
 * <collection-tabs> — subcategory tabs on a parent collection page.
 *
 * Wraps the pill row (cl-chips) when the collection is a parent of its chips. Clicking a chip
 * loads that subcollection's products into #ProductGridContainer through facets.js and leaves
 * the URL alone; the "All" tab goes back to the parent's own products.
 *
 * The chips are still real links, so modified clicks (new tab/window) and no-JS work as before.
 * facets.js reads `activeUrl` as the base path for filter/sort fetches and keeps this element
 * in place when it re-renders the grid container, so the selection survives filter changes.
 */
if (!customElements.get('collection-tabs')) {
  customElements.define(
    'collection-tabs',
    class CollectionTabs extends HTMLElement {
      constructor() {
        super();
        // Empty means the "All" tab: facets.js falls back to window.location.pathname
        this.activeUrl = '';
        // this.addEventListener('click', this.onClick.bind(this));
      }

      get chips() {
        return Array.from(this.querySelectorAll('.cl-chip'));
      }

      onClick(event) {
        const chip = event.target.closest('.cl-chip');
        if (!chip || event.defaultPrevented) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (typeof FacetFiltersForm === 'undefined' || !document.getElementById('product-grid')) return;

        event.preventDefault();
        this.select(chip);
      }

      select(chip) {
        const url = chip.hasAttribute('data-tab-all') ? '' : new URL(chip.href).pathname;
        if (url === this.activeUrl) return;

        this.activeUrl = url;
        this.markActive(chip);

        // Filters belong to the previous collection, so start clean; only an explicit sort carries over
        const sortBy = new URLSearchParams(FacetFiltersForm.searchParamsPrev || '').get('sort_by');
        const searchParams = sortBy ? new URLSearchParams({ sort_by: sortBy }).toString() : '';
        FacetFiltersForm.renderPage(searchParams, null, false);
      }

      markActive(activeChip) {
        this.chips.forEach((chip) => {
          const isActive = chip === activeChip;
          chip.classList.toggle('cl-chip--active', isActive);
          if (isActive) chip.setAttribute('aria-current', 'true');
          else chip.removeAttribute('aria-current');
        });

        const slider = this.querySelector('cl-chips-slider');
        if (activeChip && slider && typeof slider.reveal === 'function') slider.reveal(activeChip);
      }

      // Back/forward only walks the parent's own filter history, so return to "All" first.
      // Returns true when the tab changed.
      reset() {
        if (!this.activeUrl) return false;
        this.activeUrl = '';
        this.markActive(this.querySelector('[data-tab-all]'));
        return true;
      }
    }
  );
}
